import { Component, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AdminLayoutService } from '../../layouts/admin-layout/admin-layout.service';
import { CommonService } from '../../shared/common.service';

@Component({
  selector: 'app-admin-navbar',
  templateUrl: './admin-navbar.component.html',
  styleUrls: ['./admin-navbar.component.css']
})
export class AdminNavbarComponent implements OnInit, OnDestroy {

  private menuIcon!: HTMLElement | null;
  modulesList: any[] = [];

  constructor(
    private elementRef: ElementRef,
        private router: Router,
            public commonService: CommonService,
        
            public adminLayoutService: AdminLayoutService,
        
  ) { }

  ngOnInit(): void {
    this.setupNavLinkClick();
    this.setupDropdownToggle();
    this.setupOutsideClickListener();
    this.setupMenuToggle();
    this.setupViewItenaryArea();
    this.setupMedicalHistoryHeader();
    this.setupDaySelector();
    this.setupInfoButtonHandlers();
    this.setupVehicleSelect();
    this.setupPaginationArea();
    this.getModulesList();
  }

  ngOnDestroy(): void {
    // Cleanup event listeners when component is destroyed
    document.removeEventListener('click', this.handleDocumentClick);
  }

  getModulesList(): void {
    this.adminLayoutService.getAdminModulesList().subscribe(
      (response: any) => {
        if (response.code === 1) {
          localStorage.setItem('moduleData', JSON.stringify(response.data));
          this.modulesList = response.data;
          // console.log(response);
  
          // Reinitialize dropdown functionality after modulesList updates
          setTimeout(() => this.setupDropdownToggle(), 0); // Ensure the DOM is updated
        } else {
          // this.commonService.notifier.notify('error', response.message);
          this.Logout();
        }
      },
      (error) => {
        // console.log('API Error:', error);
        // this.commonService.notifier.notify('error', error);
        this.Logout();
      }
    );
  }
  

  // Handles active class for navLinks
  private setupNavLinkClick(): void {
    const navLinks: NodeListOf<HTMLElement> = this.elementRef.nativeElement.querySelectorAll('.navbar ul li .navLink');
    navLinks.forEach(link => {
      link.addEventListener('click', () => {
        navLinks.forEach(l => l.classList.remove('active'));
        link.classList.add('active');
      });
    });
  }

  // Dropdown functionality
  private setupDropdownToggle(): void {
    const dropdownLinks: NodeListOf<HTMLElement> = this.elementRef.nativeElement.querySelectorAll('.dropdown-link .navLink');
  
    dropdownLinks.forEach(link => {
      link.removeEventListener('click', this.handleDropdownClick); // Remove any previous listeners to avoid duplication
      link.addEventListener('click', this.handleDropdownClick);
    });
  }

  private handleDropdownClick = (event: Event): void => {
    event.stopPropagation();
    const target = event.currentTarget as HTMLElement;
    const submenu = target.nextElementSibling as HTMLElement;
  
    if (submenu?.classList.contains('submenuactive')) {
      submenu.classList.remove('submenuactive');
    } else {
      this.closeAllSubmenus();
      submenu?.classList.add('submenuactive');
    }
  };
  
  private closeAllSubmenus(): void {
    const allSubmenus: NodeListOf<HTMLElement> = this.elementRef.nativeElement.querySelectorAll('.dropdown-link .submenu-items');
    allSubmenus.forEach(submenu => submenu.classList.remove('submenuactive'));
  }

  // Close dropdowns when clicking outside
  private handleDocumentClick = (): void => {
    this.closeAllSubmenus();
  }

  private setupOutsideClickListener(): void {
    document.addEventListener('click', this.handleDocumentClick);
  }

  // Menu toggle bar
  private setupMenuToggle(): void {
    const togglebar: HTMLElement = this.elementRef.nativeElement.querySelector('.togglebar');
    const navbar: HTMLElement = this.elementRef.nativeElement.querySelector('.navbar');

    togglebar?.addEventListener('click', () => {
      navbar?.classList.toggle('menuactive');
    });

    this.menuIcon = this.elementRef.nativeElement.querySelector('.menu-icon');
    const lines = Array.from(this.menuIcon?.children || []) as HTMLElement[];

    this.menuIcon?.addEventListener('click', () => {
      lines.forEach(line => {
        line.classList.toggle('active');
        line.classList.toggle('no-animation');
      });
    });
  }

  // View Itenary arrow toggle
  private setupViewItenaryArea(): void {
    const viewAreas: NodeListOf<HTMLElement> = this.elementRef.nativeElement.querySelectorAll('.view-itenary-area');
    viewAreas.forEach(area => {
      area.addEventListener('click', () => {
        const upArrow = area.querySelector('.up-arrow');
        upArrow?.classList.toggle('view-iteenary-active');
      });
    });
  }

  // Medical history header button toggle
  private setupMedicalHistoryHeader(): void {
    const buttons: NodeListOf<HTMLElement> = this.elementRef.nativeElement.querySelectorAll('.madicalhistoryheader ul li button');
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        buttons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
      });
    });
  }

  // Day Selector
  private setupDaySelector(): void {
    const dayButtons: NodeListOf<HTMLElement> = this.elementRef.nativeElement.querySelectorAll('.day-selector-area button');
    dayButtons.forEach(button => {
      button.addEventListener('click', () => {
        dayButtons.forEach(btn => btn.classList.remove('dayactive'));
        button.classList.add('dayactive');
      });
    });
  }

  // Information button toggles
  private setupInfoButtonHandlers(): void {
    const itineraryBtn = this.elementRef.nativeElement.querySelector('.intineraryinfobtn');
    const basicInfoBtn = this.elementRef.nativeElement.querySelector('.basicinfobtn');

    const packageItinerary = this.elementRef.nativeElement.querySelector('.package-itinerary-information');
    const packageBasic = this.elementRef.nativeElement.querySelector('.package-basic-information');

    itineraryBtn?.addEventListener('click', () => {
      packageItinerary?.classList.add('informationActive');
      packageBasic?.classList.remove('informationActive');
    });

    basicInfoBtn?.addEventListener('click', () => {
      packageItinerary?.classList.remove('informationActive');
      packageBasic?.classList.add('informationActive');
    });
  }

  // Vehicle selection toggle
  private setupVehicleSelect(): void {
    const vehicleItems: NodeListOf<HTMLElement> = this.elementRef.nativeElement.querySelectorAll('.vahicle_item');
    vehicleItems.forEach(item => {
      item.addEventListener('click', () => {
        vehicleItems.forEach(v => v.classList.remove('selectcar'));
        item.classList.add('selectcar');
      });
    });
  }

  // Pagination
  private setupPaginationArea(): void {
    const pageLinks: NodeListOf<HTMLElement> = this.elementRef.nativeElement.querySelectorAll('.pagination-area ul li a');
    pageLinks.forEach(link => {
      link.addEventListener('click', () => {
        pageLinks.forEach(l => l.classList.remove('pageActive'));
        link.classList.add('pageActive');
      });
    });
  }

    Logout() {
       
    localStorage.clear();
    this.router.navigate(['admin/login']);
  }
}
